import {Popover, Tooltip} from './_bootstrap';

(function () {

  //
  // Bootstrap tooltips and popovers
  //

  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(tooltipElement => new Tooltip(tooltipElement))

  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(popoverElement => new Popover(popoverElement, {
      // trigger: 'focus'
    }))


  //
  // Read more list
  //

  var btns = document.querySelectorAll('.read-more-list > button');
  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentElement.classList.add('toggled');
    });
  });

  //
  // Menu 2e niveau (comportement responsive/accessible)
  //

  var toggle = document.querySelector('#toggle-main-aside-menu');
  var menu = document.querySelector('#main-aside-menu');

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-active')) {
        this.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-active');
      } else {
        menu.classList.add('is-active');
        this.setAttribute('aria-expanded', 'true');
      }
    });

    var asideMenuBtn = menu.querySelectorAll('#main-aside-menu button');
    asideMenuBtn.forEach(btn => {
      btn.addEventListener('click', () => {
        var parent = btn.parentElement;
        parent.classList.toggle('menu-item--expanded');
        btn.setAttribute('aria-expanded', parent.classList.contains('menu-item--expanded').toString());
      });
    });

  }

})();

(function (Drupal) {

  var alertTypes = {
    status: {variant: 'success', icon: 'icon-check-circle'},
    warning: {variant: 'warning', icon: 'icon-warning'},
    error: {variant: 'danger', icon: 'icon-x-circle'},
    info: {variant: 'info', icon: 'icon-info-circle'},
  };

  Drupal.theme.message = function ({text}, {type, id}) {
    var labels = Drupal.Message.getMessageTypeLabels();
    var alert = alertTypes[type] || alertTypes.info;
    var wrapper = document.createElement('div');

    wrapper.setAttribute('class', `alert alert-${alert.variant} alert-dismissible d-flex`);
    wrapper.setAttribute('role', type === 'error' || type === 'warning' ? 'alert' : 'status');
    wrapper.setAttribute('data-drupal-message-id', id);
    wrapper.setAttribute('data-drupal-message-type', type);
    wrapper.setAttribute('aria-label', labels[type]);

    wrapper.innerHTML =
      `<div class="alert-icon text-${alert.variant}"><span class="${alert.icon}"></span></div>` +
      `<div class="alert-content align-self-center">${text}` +
      `<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`;

    return wrapper;
  };

})(Drupal);

(function ($, Drupal) {
  Drupal.behaviors.enap_theme = {
    attach: function (context, settings) {
      $('.form-autocomplete', context).on('focus', function (e) {
        e.target.setSelectionRange(e.target.value.length, e.target.value.length)
      })
    }
  };
})(jQuery, Drupal);
